/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconBrushOff = createSolidComponent("brush-off", "IconBrushOff", [
  ["path", { d: "M3 17a4 4 0 1 1 4 4h-4v-4z" }],
  [
    "path",
    {
      d: "M21 3a16 16 0 0 0 -9.309 4.704m-1.795 2.212a15.993 15.993 0 0 0 -1.696 3.284"
    }
  ],
  [
    "path",
    {
      d: "M21 3a16 16 0 0 1 -4.697 9.302m-2.195 1.786a15.993 15.993 0 0 1 -3.308 1.712"
    }
  ],
  ["path", { d: "M3 3l18 18" }]
]);

export { IconBrushOff as default };
//# sourceMappingURL=IconBrushOff.js.map
